export default "__VITE_ASSET__j1$GN_Y3__"